// Components
import { Box, Flex, Text } from 'yard-utilities/components'

// Styles
import styles from './Tag.module.sass'

interface TagProps {
  backgroundColor: string
  backgroundOpacity?: number
  variant?:
    | 'type-1'
    | 'type-2'
    | 'type-3'
    | 'type-4'
    | 'type-5'
    | 'type-6'
    | 'type-7'
  textColor?: string
  textSize?: string
  fontWeight?: 400 | 500 | 600 | 700
  children: React.ReactNode
}

const Tag = ({
  backgroundColor,
  backgroundOpacity = 100,
  variant = 'type-1',
  textColor = 'white',
  textSize = 'body-5',
  fontWeight = 600,
  children
}: TagProps) => {
  return (
    <Box
      backgroundColor={backgroundColor}
      opacity={backgroundOpacity}
      borderRadius={{ sm: [8] }}
      className={`${styles.tag} ${styles[variant]}`}
    >
      <Flex fullHeight fullWidth center>
        <Text
          variant={textSize}
          fontWeight={fontWeight}
          textColor={textColor}
          className={styles.text}
        >
          {children}
        </Text>
      </Flex>
    </Box>
  )
}

export default Tag
